"use client";

import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

const analytics = new AnalyticsBrowser();

export default analytics;
